module.exports = __webpack_public_path__ + "img/img-2.bb0f65d2.jpg";